import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSiren = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-siren",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M7 18v-6a5 5 0 1 1 10 0v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 12h1" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.5 4.5 18 5" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 12h1" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 2v1" }),
		/* @__PURE__ */ _jsx("path", { d: "m4.929 4.929.707.707" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 12v6" })
	]
});
export default SvgSiren;
